import { pushAlert } from '@/services/messages/alertService';
import store from '@/store';

const MA113 = 'MA113';
const PROBE_INTERVAL_MS = 15000;

let probeTimer = null;
let circuitAlert = null;

export function isConnectionError(error) {
  return !error.response;
}

function stopTimer() {
  if (probeTimer) {
    clearInterval(probeTimer);
    probeTimer = null;
  }
}

export function reset() {
  stopTimer();
  if (circuitAlert) {
    circuitAlert.dismiss();
    circuitAlert = null;
  }
  store.dispatch('setApiUnreachable', false);
}

export function trip(probe) {
  if (store.getters.apiUnreachable) return;
  store.dispatch('setApiUnreachable', true);
  circuitAlert = pushAlert({ code: MA113, autoDismissible: false });
  stopTimer();
  probeTimer = setInterval(probe, PROBE_INTERVAL_MS);
}
